export default {
    GET_ALL_PROPERTY: () => '/CustomProperty',
    UPDATE_PROPERTY: (id) => `/CustomProperty/${id}`,
    GET_PROPERTY_BY_ID: (id) => `/CustomProperty/${id}`,
    DELETE_PROPERTY: (id) => `/CustomProperty/${id}`,
    CREATE_PROPERTY: () => '/CustomProperty',
    GET_PROPERTY_BY_BOARD_ID: (id) => `/CustomProperty/board/${id}`,
    CREATE_CUSTOM_FIELD: () => '/CustomProperty',
    GET_ALL_PROPERTY: () => '/CustomProperty',
    UPDATE_PROPERTY: (id) => `/CustomProperty/${id}`,
    UPDATE_PROPERTY_BY_POSITION: (id) => `/CustomProperty/${id}`,

};
